import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Zap } from 'lucide-mui';
import useLimits from '../../plan/hooks/limits';

const TranscriptLimitReached: React.FC = () => {
  const guardLimits = useLimits();

  const handleUpgradeClick = () => {
    guardLimits('transcription', () => {
      // Redirect to the upgrade page or handle the upgrade logic here
      console.log('Upgrade process initiated for transcription feature.');
    });
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
      textAlign="center"
      bgcolor="background.paper"
      p={2}
      role="alert"
    >
      <Typography variant="h5" color="textPrimary" mt={1}>
        Get Unlimited Transcriptions
      </Typography>
      <Typography variant="body1" color="textSecondary" mt={1}>
        You&apos;ve reached your free transcription limit. Upgrade now to
        transcribe as many files as you need.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={<Zap />}
        onClick={handleUpgradeClick}
        sx={{ mt: 2 }}
      >
        Upgrade
      </Button>
    </Box>
  );
};

export default TranscriptLimitReached;
